const state = {
  list: [
    { id: 3  ,         name: "Moedas Copa 2014" },
    { id: 4  ,         name: "Novidades" },
    { id: 5  ,         name: "Moedas por País" },
    { id: 16 , own: 5, name: "BRASIL" },
    { id: 25 , own: 5, name: "EUROPA" },
      { id: 105, name: "América do Norte e Central", own: 5 },
      { id: 151, name: "América do Sul", own: 5 },
      { id: 169, name: "ÁFRICA", own: 5 },
      { id: 227, name: "Oriente Médio", own: 5 },
      { id: 247, name: "Ásia", own: 5 },
      { id: 282, name: "Oceania", own: 5 },
    { id: 6  , name: "Moedas por Metais" },
      { id: 321, name: "Prata", own: 6 },
      { id: 322, name: "Ouro", own: 6 },
      { id: 323, name: "Titânio", own: 6 },
      { id: 324, name: "Niobio", own: 6 },
      { id: 325, name: "Platina", own: 6 },
      { id: 326, name: "Bi e multi metálicas", own: 6 },
      { id: 327, name: "Paládio", own: 6 },
      { id: 328, name: "Rutênio", own: 6 },
      { id: 329, name: "Tântalo", own: 6 },
    { id: 7  , name: "Moedas Antigas" },
      { id: 330, name: "Celtas", own: 7 },
      { id: 331, name: "Gregas", own: 7 },
      { id: 332, name: "Romanas", own: 7 },
      { id: 333, name: "Bizantinas", own: 7 },
      { id: 334, name: "Medievais", own: 7 },
      { id: 335, name: "Islâmicas", own: 7 },
      { id: 336, name: "Asiáticas Antigas", own: 7 },
    { id: 8  , name: "Medalhas" },
    { id: 9  , name: "Suprimento" },
      { id: 338, name: "Moedas", own: 9 },
      { id: 347, name: "Cédulas", own: 9 },
    { id: 10 , name: "Catálogos" },
    { id: 11 , name: "Documentos" },
    { id: 12 , name: "Cartão Telefônico" },
      { id: 350, name: "Nacionais", own: 12 },
      { id: 351, name: "Internacionais", own: 12 },
    { id: 13 , name: "Antiguidades" },
    { id: 14 , name: "Cartão Postal" },
    { id: 15 , name: "Arte" }
  ]
}

const getters = {
  tree() {
    function getNodes(id, depth) {
      let nodes = [];
      id = id || null;
      depth = depth || 1;
      for (let item of state.list) {
        if (item.own==id) {
          nodes.push({
            id: item.id,
            name: item.name,
            children: getNodes(item.id, depth+1),
            depth
          });
        }
      }
      return nodes;
    }

    return getNodes()
  },
  root() {
    return {
      id: 0,
      name: 'root',
      children: getters.tree(),
      depth: 0
    }
  }
}

export default {
  state,
  getters
}
